import { Component, inject, ViewChild } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Store } from '@ngxs/store';
import { Popover } from 'primeng/popover';
import { FormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { NotificationsService } from 'src/app/core/services/notifications.service';
import { NotificationState} from 'src/app/shared/store/states/notifications/notification.state';
import { SearchService } from 'src/app/shared/services/search.service';
import { SearchResultsComponent } from 'src/app/core/components/search-results/search-results.component';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { AnalyticsEventName } from 'src/app/core/enums/analytics.enum';

@Component({
  selector: 'app-toolbar',
  imports: [
    Popover,
    FormsModule,
    AsyncPipe,
    SearchResultsComponent
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
  standalone: true
})
export class ToolbarComponent {
  private readonly analyticsService = inject(AnalyticsService);
  protected readonly notificationsService = inject(NotificationsService);
  protected readonly searchService = inject(SearchService);
  protected readonly store = inject(Store);

  @ViewChild('popover') popover!: Popover;

  protected readonly searchTerm$ = this.searchService.searchTerm$;

  protected readonly hasUnreadNotifications$: Observable<boolean> =
    this.store.select(NotificationState.getNotifications).pipe(
      map(notifications => notifications.some(n => !n.isRead))
    );

  protected handlePopover(event: Event): void {
    if (this.searchTerm$.value && this.popover) {
      this.popover.show(event);
    } else {
      this.popover.hide();
    }
  }

  protected handleOpenNotifications(): void {
    this.analyticsService.trackEvent(AnalyticsEventName.ItemClick, {
      itemName: 'notifications',
      itemId: 'notifications'
    });
    this.notificationsService.toggleNotifications();
  }

  protected onClearSearch(): void {
    this.searchTerm$.next('');

    if (this.popover) {
      this.popover.hide();
    }
  }
}
